/* eslint-disable default-case */

/****
* Validation module
* Usage:
* import isGood from "../libs/validation";
* if (!isGood("name", name)) ...
****/
export default function isGood(type, data) {
  let
    emailRe     = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\S*$/,
    recoveryRe  = /^[0-9a-zA-Z\%\$\.\/]{60}$/g,
    tokenRe     = /^[0-9a-zA-Z\%\$\.\/-]{200,500}/g,
    confTokenRe = /^[0-9a-zA-Z\%\$\.\/-]{30,50}/,
    nameRe      = /^[\sa-zA-Z\u00E0-\u00FC\u00C0-\u00DC\u00C7']+$/,
    // namePlusRe  = /^[\,\.\sa-zA-Z0-9\u00E0-\u00FC\u00C0-\u00DC\u00C7']+$/,
    // namePlusRe  = /^[a-zA-Z0-9,.!?& ]*$/,
    zipRe       = /(^\d{5}$)|(^\d{5}-\d{4}$)/,
    phoneRe     = /^[()--\s0-9]{10,14}$/,
    rfcRe       = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
    curpRe      = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
    suiteNum    = /^[a-zA-Z0-9 .,;/-]+$/;

  switch (type) {
    case "rfc":
      /***** > Individuals, it consists of 13 characters (4 letters followed by 6 digits and 3 alphanumeric characters)
      > Legal persons (and certain legal arrangements), it consists of 12 characters (3 letters followed by 6 digits and 3 alphanumeric characters).
      -- The first letters (4 or 3, respectively) belong to the name, the next 6 digits are the date of birth or date of incorporation, and the last 3 (or 2, for legal entities) belong to the check digits (homoclave). *****/
      return rfcRe.test(data);

    case "curp":
      return curpRe.test(data);

    case "email":
      return emailRe.test(data);

    case "password":
      return (data.length > 5 ? true : false);

    case "confirmation":
      return confTokenRe.test(data);

    case "recovery":
      return recoveryRe.test(data);

    case "token":
      return tokenRe.test(data);

    case "zip":
      return zipRe.test(data);

    case "phone":
      return phoneRe.test(data);

    case "int":
    case "number":
      return Number.isInteger(parseInt(data));

    case "suiteNum":
      return suiteNum.test(data);
      
    case "name":
      if (data.length < 2) return false;
      return nameRe.test(data);

    case "none":
      return true;

  } // END switch

} // END isGood



// WEBPACK FOOTER //
// ./src/libs/isGood.js